(() => {
  'use strict';
  function init(root) {
    if (root.dataset.yhwl26cReady) return;
    root.dataset.yhwl26cReady = '1';
    const grid = root.querySelector('[data-yhwl26c-grid]');
    if (!grid) return;
    const footer = root.querySelector('[data-yhwl26c-footer]');
    const notice = root.querySelector('[data-yhwl26c-notice]');
    let loading = false;
    let observer;
    function message(text, isError=false) {
      if (!notice) return;
      notice.textContent = text;
      if (!isError) {
        const a = document.createElement('a');
        a.href = root.dataset.yhwl26cCartUrl || '/cart';
        a.textContent = ' View Cart';
        notice.append(a);
      }
      notice.hidden = false;
      setTimeout(() => { notice.hidden = true; }, 5000);
    }
    async function loadMore() {
      const next = footer.querySelector('[data-yhwl26c-next]');
      if (loading || !next) return;
      loading = true;
      next.setAttribute('aria-busy', 'true');
      const url = new URL(next.href, window.location.origin);
      url.searchParams.set('section_id', root.dataset.yhwl26cSection);
      try {
        const response = await fetch(url.toString(), { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Load failed');
        const html = await response.text();
        const documentPage = new DOMParser().parseFromString(html, 'text/html');
        const feed = documentPage.querySelector('[data-yhwl26c-root]');
        const incoming = feed && feed.querySelector('[data-yhwl26c-grid]');
        if (!incoming) throw new Error('Invalid response');
        const newCards = [...incoming.querySelectorAll('[data-yhwl26c-card]')];
        if (!newCards.length) throw new Error('No products found');
        grid.append(...newCards);
        const nextFooter = feed.querySelector('[data-yhwl26c-footer]');
        footer.innerHTML = nextFooter ? nextFooter.innerHTML : '';
        if (observer && !footer.querySelector('[data-yhwl26c-next]')) observer.disconnect();
      } catch (err) {
        message('Unable to load more. Please try again.', true);
        next.textContent = 'Retry loading';
      } finally {
        loading = false;
        const btn = footer.querySelector('[data-yhwl26c-next]');
        if (btn) btn.removeAttribute('aria-busy');
      }
    }
    footer.addEventListener('click', (event) => {
      const link = event.target.closest('[data-yhwl26c-next]');
      if (!link) return;
      event.preventDefault();
      loadMore();
    });
    if (root.dataset.yhwl26cMode === 'infinite' && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        if (entries.some(item => item.isIntersecting)) loadMore();
      }, { rootMargin: '0px 0px 600px 0px' });
      observer.observe(footer);
    }
    // Delegated toggle also works for new products appended by infinite pagination.
    root.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-yhwl26c-toggle]');
      if (!toggle) return;
      const media = toggle.closest('[data-yhwl26c-media]');
      const anchor = media && media.querySelector('.yhwl26c__image');
      const template = media && media.querySelector('[data-yhwl26c-look-template]');
      if (!anchor || !template) return;
      if (!media.dataset.yhwl26cOriginal) media.dataset.yhwl26cOriginal = anchor.innerHTML;
      const looking = toggle.getAttribute('aria-pressed') === 'true';
      anchor.innerHTML = looking ? media.dataset.yhwl26cOriginal : template.innerHTML;
      toggle.setAttribute('aria-pressed', String(!looking));
      toggle.textContent = looking ? 'View The Look' : 'Product Photo';
    });
    root.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-yhwl26c-add]');
      if (!button || button.disabled) return;
      const card = button.closest('[data-yhwl26c-card]');
      const selection = card && card.querySelector('[data-yhwl26c-variant]');
      if (!selection || !selection.value) return;
      button.disabled = true;
      const original = button.textContent;
      button.textContent = 'Adding…';
      try {
        const rootUrl = root.dataset.yhwl26cRootUrl || '/';
        const base = rootUrl.endsWith('/') ? rootUrl : `${rootUrl}/`;
        const res = await fetch(`${base}cart/add.js`, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(selection.value), quantity: 1 }] })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || 'Unable to add item');
        message('Added to cart.');
        const bubble = document.querySelector('#cart-icon-bubble');
        if (bubble) {
          const cartRes = await fetch(`${base}cart.js`);
          if (cartRes.ok) {
            const cart = await cartRes.json();
            const visible = bubble.querySelector('.cart-count-bubble span:not(.visually-hidden)');
            const invisible = bubble.querySelector('.cart-count-bubble .visually-hidden');
            if (visible) visible.textContent = cart.item_count;
            if (invisible) invisible.textContent = `${cart.item_count} items`;
          }
        }
      } catch (error) {
        message(error.message || 'Add To Cart failed.', true);
      } finally {
        button.disabled = false;
        button.textContent = original;
      }
    });
  }
  function mount() { document.querySelectorAll('[data-yhwl26c-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();
